import { PrescriptionType } from '@alberta/konexi-shared';
import { cloneDeep, groupBy } from 'lodash';
import { PrescriptionNodeValue } from 'src/app/shared/models/prescription/prescription-node-value.model';
import { PrescriptionRequestDto } from 'src/app/shared/models/prescription/prescription-request-dto.model';

import { PrescriptionChainHandler } from './prescription-chain-handler';
import { convertArticleLines } from './prescription-chain-helpers';

export class GroupByPrescriptionTypeHandler extends PrescriptionChainHandler {
  async handleRequest(prescriptionRequestDto: PrescriptionRequestDto, request: PrescriptionNodeValue) {
    const articleLinesGroupedByPrescriptionType = groupBy(request.articleLines, line => {
      switch (line.article.prescriptionType) {
        case PrescriptionType.AdisForConsumption:
        case PrescriptionType.AidsForUse:
          return PrescriptionType.AdisForConsumption;
        case PrescriptionType.Drug:
        case PrescriptionType.Dressings:
          return PrescriptionType.Drug;
        default:
          return line.article.prescriptionType;
      }
    });

    const prescriptionTypes = Object.keys(articleLinesGroupedByPrescriptionType);
    if (prescriptionTypes.length === 1) {
      // we already created this prescription in the previous handler so we can go to the next handler here
      prescriptionRequestDto.prescriptions[0].medicalAidPrescription = prescriptionTypes[0] === PrescriptionType.AdisForConsumption.toString(); 
      prescriptionRequestDto.prescriptions[0].tubeFeedingNutrition = prescriptionTypes[0] === PrescriptionType.TubeFeeding.toString(); 
      
      return this.next.handleRequest(prescriptionRequestDto, request);
    }
    const currentPresciption = prescriptionRequestDto.prescriptions[0];
    prescriptionRequestDto.prescriptions = [];
    for (const prescriptionType of prescriptionTypes) {
      const additionalPrescription = cloneDeep(currentPresciption);

      additionalPrescription.medicalAidPrescription = prescriptionType === PrescriptionType.AdisForConsumption.toString(); 
      additionalPrescription.tubeFeedingNutrition = prescriptionType === PrescriptionType.TubeFeeding.toString(); 

      additionalPrescription.positions = convertArticleLines(articleLinesGroupedByPrescriptionType[prescriptionType]);
      prescriptionRequestDto.prescriptions.push(additionalPrescription);
    }
    return this.next.handleRequest(prescriptionRequestDto, request);
  }
}
